import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Layout from '../components/layout';

const RecommendShop = () => {
    const pageTitle = 'Recommend a Supplier';

    const [phone, setPhone] = useState(false);
    const [email, setEmail] = useState(false);
    const [social, setSocial] = useState(false);

    return (
        <Layout>
            <Helmet>
                <title>{pageTitle}</title>
            </Helmet>
            <div className="container section">
                <h1>Who's Your Go To?</h1>
                <p>
                    Do you have a reliable guy? Is there a place you call
                    regularly to deliver? Do you or someone you know sell
                    firewood? If so, please fill out the form below to share
                    your love of fire with the rest of the wood burning
                    community. We'll check them out and add them to the list.
                </p>
                <div>
                    <form
                        className="jotform-form"
                        action="https://submit.jotform.com/submit/220467284701050/"
                        method="post"
                        name="form_220467284701050"
                        id="220467284701050"
                        acceptCharset="utf-8"
                        autoComplete="on"
                    >
                        <input
                            type="hidden"
                            name="formID"
                            value="220467284701050"
                        />
                        <input type="hidden" id="JWTContainer" />
                        <input type="hidden" id="cardinalOrderNumber" />
                        <div role="main" className="form-all">
                            <ul className="form-section page-section">
                                <li id="cid_4" className="form-input-wide">
                                    <div className="form-header-group  header-default">
                                        <div className="header-text httal htvam">
                                            <h2
                                                id="header_4"
                                                className="form-header"
                                            >
                                                Supplier Information
                                            </h2>
                                        </div>
                                    </div>
                                </li>
                                <li className="form-line" id="id_6">
                                    <label
                                        className="form-label form-label-top form-label-auto"
                                        id="label_6"
                                        htmlFor="input_6"
                                    >
                                        Business Name
                                        <span className="form-required">*</span>
                                    </label>
                                    <div id="cid_6" className="form-input-wide">
                                        <input
                                            type="text"
                                            id="input_6"
                                            name="q6_businessName"
                                            className="form-textbox validate[required]"
                                            aria-labelledby="label_6"
                                            required
                                        />
                                    </div>
                                </li>
                                <li className="form-line" id="id_35">
                                    <label
                                        className="form-label form-label-top form-label-auto"
                                        id="label_35"
                                        htmlFor="input_35"
                                    >
                                        Best Way to Contact
                                    </label>
                                    <div
                                        id="cid_35"
                                        className="form-input-wide"
                                    >
                                        <div
                                            className="form-single-column"
                                            role="group"
                                            aria-labelledby="label_35"
                                        >
                                            <span className="form-checkbox-item flex items-center">
                                                <input
                                                    type="checkbox"
                                                    aria-describedby="label_35"
                                                    className="form-checkbox mr-2"
                                                    id="input_35_0"
                                                    name="q35_bestWay[]"
                                                    value="Phone"
                                                    checked={phone}
                                                    onChange={(e) => {
                                                        setPhone(
                                                            e.target.checked
                                                        );
                                                    }}
                                                />
                                                <label
                                                    id="label_input_35_0"
                                                    htmlFor="input_35_0"
                                                >
                                                    Phone
                                                </label>
                                            </span>
                                            <span className="form-checkbox-item flex items-center">
                                                <input
                                                    type="checkbox"
                                                    aria-describedby="label_35"
                                                    className="form-checkbox mr-2"
                                                    id="input_35_1"
                                                    name="q35_bestWay[]"
                                                    value="Email"
                                                    checked={email}
                                                    onChange={(e) => {
                                                        setEmail(
                                                            e.target.checked
                                                        );
                                                    }}
                                                />
                                                <label
                                                    id="label_input_35_1"
                                                    htmlFor="input_35_1"
                                                >
                                                    Email
                                                </label>
                                            </span>
                                            <span className="form-checkbox-item flex items-center">
                                                <input
                                                    type="checkbox"
                                                    aria-describedby="label_35"
                                                    className="form-checkbox mr-2"
                                                    id="input_35_2"
                                                    name="q35_bestWay[]"
                                                    value="Social"
                                                    checked={social}
                                                    onChange={(e) => {
                                                        setSocial(
                                                            e.target.checked
                                                        );
                                                    }}
                                                />
                                                <label
                                                    id="label_input_35_2"
                                                    htmlFor="input_35_2"
                                                >
                                                    Social
                                                </label>
                                            </span>
                                        </div>
                                    </div>
                                </li>
                                <li
                                    className="form-line"
                                    id="id_9"
                                    style={{
                                        display: phone ? 'block' : 'none'
                                    }}
                                >
                                    <label
                                        className="form-label form-label-top form-label-auto"
                                        id="label_9"
                                        htmlFor="input_9_full"
                                    >
                                        Phone Number
                                        <span className="form-required">*</span>
                                    </label>
                                    <div id="cid_9" className="form-input-wide">
                                        <span className="form-sub-label-container">
                                            <input
                                                type="tel"
                                                id="input_9_full"
                                                name="q9_phoneNumber[full]"
                                                className="mask-phone-number form-textbox validate[required, Fill Mask]"
                                                autoComplete="section-input_9 tel-national"
                                                placeholder="(000) 000-0000"
                                                aria-labelledby="label_9 sublabel_9_masked"
                                                required={phone}
                                            />
                                            <label
                                                className="form-sub-label"
                                                htmlFor="input_9_full"
                                                id="sublabel_9_masked"
                                                aria-hidden="false"
                                            >
                                                Please enter a valid phone
                                                number.
                                            </label>
                                        </span>
                                    </div>
                                </li>
                                <li
                                    className="form-line"
                                    id="id_10"
                                    style={{
                                        display: email ? 'block' : 'none'
                                    }}
                                >
                                    <label
                                        className="form-label form-label-top form-label-auto"
                                        id="label_10"
                                        htmlFor="input_10"
                                    >
                                        Email
                                        <span className="form-required">*</span>
                                    </label>
                                    <div
                                        id="cid_10"
                                        className="form-input-wide"
                                    >
                                        <span className="form-sub-label-container">
                                            <input
                                                type="email"
                                                id="input_10"
                                                name="q10_email10"
                                                className="form-textbox validate[Email]"
                                                size="310"
                                                aria-labelledby="label_10 sublabel_input_10"
                                                required={email}
                                            />
                                            <label
                                                className="form-sub-label"
                                                htmlFor="input_10"
                                                id="sublabel_input_10"
                                                aria-hidden="false"
                                            >
                                                example@example.com
                                            </label>
                                        </span>
                                    </div>
                                </li>
                                <li
                                    className="form-line form-field-hidden"
                                    id="id_36"
                                    style={{
                                        display: social ? 'block' : 'none'
                                    }}
                                >
                                    <label
                                        className="form-label form-label-top form-label-auto"
                                        id="label_36"
                                        htmlFor="input_36"
                                    >
                                        Social
                                        <span className="form-required">*</span>
                                    </label>
                                    <div
                                        id="cid_36"
                                        className="form-input-wide"
                                    >
                                        <span className="form-sub-label-container">
                                            <input
                                                type="text"
                                                id="input_36"
                                                name="q36_social"
                                                className="form-textbox"
                                                size="310"
                                                aria-labelledby="label_36 sublabel_input_36"
                                                required={social}
                                            />
                                            <label
                                                className="form-sub-label"
                                                htmlFor="input_36"
                                                id="sublabel_input_36"
                                                aria-hidden="false"
                                            >
                                                Please enter the appropriate
                                                social link, or include the
                                                platform and username for
                                                reference.
                                            </label>
                                        </span>
                                    </div>
                                </li>
                                <li className="form-line" id="id_5">
                                    <label
                                        className="form-label form-label-top form-label-auto"
                                        id="label_5"
                                        htmlFor="input_5_addr_line1"
                                    >
                                        Address
                                        <span className="form-required">*</span>
                                    </label>
                                    <div id="cid_5" className="form-input-wide">
                                        <div
                                            summary=""
                                            className="form-address-table jsTest-addressField"
                                        >
                                            <div className="form-address-line-wrapper jsTest-address-line-wrapperField">
                                                <span className="form-address-line form-address-street-line jsTest-address-lineField">
                                                    <span className="form-sub-label-container">
                                                        <input
                                                            type="text"
                                                            id="input_5_addr_line1"
                                                            name="q5_address[addr_line1]"
                                                            className="form-textbox validate[required] form-address-line"
                                                            autoComplete="section-input_5 address-line1"
                                                            aria-labelledby="label_5 sublabel_5_addr_line1"
                                                            required
                                                        />
                                                        <label
                                                            className="form-sub-label"
                                                            htmlFor="input_5_addr_line1"
                                                            id="sublabel_5_addr_line1"
                                                            aria-hidden="false"
                                                        >
                                                            Street Address
                                                        </label>
                                                    </span>
                                                </span>
                                            </div>
                                            <div className="form-address-line-wrapper jsTest-address-line-wrapperField">
                                                <span className="form-address-line form-address-city-line jsTest-address-lineField ">
                                                    <span className="form-sub-label-container">
                                                        <input
                                                            type="text"
                                                            id="input_5_city"
                                                            name="q5_address[city]"
                                                            className="form-textbox validate[required] form-address-city"
                                                            autoComplete="section-input_5 address-level2"
                                                            aria-labelledby="label_5 sublabel_5_city"
                                                            required
                                                        />
                                                        <label
                                                            className="form-sub-label"
                                                            htmlFor="input_5_city"
                                                            id="sublabel_5_city"
                                                            aria-hidden="false"
                                                        >
                                                            City
                                                        </label>
                                                    </span>
                                                </span>
                                                <span className="form-address-line form-address-state-line jsTest-address-lineField ">
                                                    <span className="form-sub-label-container">
                                                        <input
                                                            type="text"
                                                            id="input_5_state"
                                                            name="q5_address[state]"
                                                            className="form-textbox validate[required] form-address-state"
                                                            autoComplete="section-input_5 address-level1"
                                                            aria-labelledby="label_5 sublabel_5_state"
                                                            required
                                                        />
                                                        <label
                                                            className="form-sub-label"
                                                            htmlFor="input_5_state"
                                                            id="sublabel_5_state"
                                                            aria-hidden="false"
                                                        >
                                                            State
                                                        </label>
                                                    </span>
                                                </span>
                                            </div>
                                            <div className="form-address-line-wrapper jsTest-address-line-wrapperField">
                                                <span className="form-address-line form-address-zip-line jsTest-address-lineField ">
                                                    <span className="form-sub-label-container">
                                                        <input
                                                            type="text"
                                                            id="input_5_postal"
                                                            name="q5_address[postal]"
                                                            className="form-textbox validate[required] form-address-postal"
                                                            autoComplete="section-input_5 postal-code"
                                                            aria-labelledby="label_5 sublabel_5_postal"
                                                            required
                                                        />
                                                        <label
                                                            className="form-sub-label"
                                                            htmlFor="input_5_postal"
                                                            id="sublabel_5_postal"
                                                            aria-hidden="false"
                                                        >
                                                            Zip Code
                                                        </label>
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li id="cid_3" className="form-input-wide">
                                    <div className="form-header-group  header-default">
                                        <div className="header-text httal htvam">
                                            <h2
                                                id="header_3"
                                                className="form-header"
                                            >
                                                Your Information
                                            </h2>
                                        </div>
                                    </div>
                                </li>
                                <li className="form-line" id="id_7">
                                    <label
                                        className="form-label form-label-top form-label-auto"
                                        id="label_7"
                                        htmlFor="first_7"
                                    >
                                        Name
                                        <span className="form-required">*</span>
                                    </label>
                                    <div id="cid_7" className="form-input-wide">
                                        <div data-wrapper-react="true">
                                            <span className="form-sub-label-container">
                                                <input
                                                    type="text"
                                                    id="first_7"
                                                    name="q7_name[first]"
                                                    className="form-textbox validate[required]"
                                                    autoComplete="section-input_7 given-name"
                                                    size="10"
                                                    aria-labelledby="label_7 sublabel_7_first"
                                                    required
                                                />
                                                <label
                                                    className="form-sub-label"
                                                    htmlFor="first_7"
                                                    id="sublabel_7_first"
                                                    aria-hidden="false"
                                                >
                                                    First Name
                                                </label>
                                            </span>
                                            <span className="form-sub-label-container">
                                                <input
                                                    type="text"
                                                    id="last_7"
                                                    name="q7_name[last]"
                                                    className="form-textbox validate[required]"
                                                    autoComplete="section-input_7 family-name"
                                                    size="15"
                                                    aria-labelledby="label_7 sublabel_7_last"
                                                    required
                                                />
                                                <label
                                                    className="form-sub-label"
                                                    htmlFor="last_7"
                                                    id="sublabel_7_last"
                                                    aria-hidden="false"
                                                >
                                                    Last Name
                                                </label>
                                            </span>
                                        </div>
                                    </div>
                                </li>
                                <li className="form-line" id="id_8">
                                    <label
                                        className="form-label form-label-top form-label-auto"
                                        id="label_8"
                                        htmlFor="input_8"
                                    >
                                        Email
                                        <span className="form-required">*</span>
                                    </label>
                                    <div id="cid_8" className="form-input-wide">
                                        <span className="form-sub-label-container">
                                            <input
                                                type="email"
                                                id="input_8"
                                                name="q8_email"
                                                className="form-textbox validate[required, Email]"
                                                size="310"
                                                aria-labelledby="label_8 sublabel_input_8"
                                                required
                                            />
                                            <label
                                                className="form-sub-label"
                                                htmlFor="input_8"
                                                id="sublabel_input_8"
                                                aria-hidden="false"
                                            >
                                                example@example.com
                                            </label>
                                        </span>
                                    </div>
                                </li>
                                <li className="form-line" id="id_34">
                                    <label
                                        className="form-label form-label-top form-label-auto"
                                        id="label_34"
                                        htmlFor="input_34"
                                    >
                                        Can we reach out to you?
                                    </label>
                                    <div
                                        id="cid_34"
                                        className="form-input-wide"
                                    >
                                        <div
                                            className="form-single-column"
                                            role="group"
                                            aria-labelledby="label_34"
                                        >
                                            <span className="form-checkbox-item flex items-center">
                                                <input
                                                    type="checkbox"
                                                    aria-describedby="label_34"
                                                    className="form-checkbox mr-2"
                                                    id="input_34_0"
                                                    name="q34_canWe[]"
                                                    value="Yes"
                                                />
                                                <label
                                                    id="label_input_34_0"
                                                    htmlFor="input_34_0"
                                                >
                                                    Yes
                                                </label>
                                            </span>
                                        </div>
                                    </div>
                                </li>
                                <li className="form-line" id="id_2">
                                    <div id="cid_2" className="form-input-wide">
                                        <div className="form-buttons-wrapper form-buttons-auto   jsTest-button-wrapperField">
                                            <button
                                                id="input_2"
                                                type="submit"
                                                className="form-submit-button submit-button jf-form-buttons jsTest-submitField"
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ display: 'none' }}>
                                    Should be Empty:
                                    <input type="text" name="website" />
                                </li>
                            </ul>
                        </div>
                        <input
                            type="hidden"
                            className="simple_spc"
                            id="simple_spc"
                            name="simple_spc"
                            value="220467284701050"
                        />
                    </form>
                </div>
            </div>
        </Layout>
    );
};

export default RecommendShop;
